import * as types from "../loanPlanActionTypes";

export default function loanPlan(state = {}, action) {
  switch (action.type) {
    case types.RECEIVE_LOAN_PLAN:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/loans/reducers/loanPlanReducer.js